import { combineReducers } from 'redux';
import { NAME as reservationsKey, reservationsReducer } from './reservations';
import { NAME as resourcesKey, resourcesReducer } from './resources';
import { NAME as guestsDialogKey, guestsDialogReducer } from './guestsDialog';
import { NAME as spaceDialogKey, spaceDialogReducer } from './spaceDialog';

export const NAME = 'summary';

export const summaryReducer = combineReducers({
    [reservationsKey]: reservationsReducer,
    [resourcesKey]: resourcesReducer,
    [guestsDialogKey]: guestsDialogReducer,
    [spaceDialogKey]: spaceDialogReducer,
});
